import React from 'react';
import './Statistics.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import CountUp from './CountUp';

const Statistics = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="statistics" id="training">
      <div className="statistics-content">
        <div className="statistics-main">
          <h2 className="statistics-number"><CountUp end={t.statisticsNumber} duration={2500} /></h2>
          <p className="statistics-description">
            {t.statisticsDescription}
          </p>
        </div>
        
        <div className="statistics-cards">
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-logo">
                <img 
                  src="/logos/logo-mnu.png" 
                  alt="MNU"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="stat-items">
                <div className="stat-item">
                  <span className="stat-number"><CountUp end="3500+" /></span>
                  <p className="stat-text">{t.statisticsMnuText}</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number secondary"><CountUp end="450+" /></span>
                  <p className="stat-text small">{t.statisticsMnuTextSmall}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-logo">
                <img 
                  src="/logos/logo-aitu.png" 
                  alt="AITU"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="stat-items">
                <div className="stat-item">
                  <span className="stat-number"><CountUp end="1200+" /></span>
                  <p className="stat-text">{t.statisticsAituText}</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number secondary"><CountUp end="200+" /></span>
                  <p className="stat-text small">{t.statisticsAituTextSmall}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-card-content">
              <div className="stat-logo">
                <img 
                  src="/logos/logo-alpha-education.png" 
                  alt="Alpha Education"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="stat-items">
                <div className="stat-item">
                  <span className="stat-number"><CountUp end="350+" /></span>
                  <p className="stat-text">{t.statisticsAlphaText}</p>
                </div>
                <div className="stat-item">
                  <p className="stat-text small">{t.statisticsAlphaTextSmall}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;

